<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="版本号：" prop="version">
                <el-input v-model="model.version"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model="model.remark"></el-input>
            </el-form-item>
            <el-form-item label="上传文件：" prop="url" class="tipsitem">
                <el-upload
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    :show-file-list="true"
                    :limit="1"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload"
                    :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import config from '@/config'

export default {
    name: 'appVersionEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                version: '',
                url: '',
                remark: '',
            },
            getObj:{
                url:'/api/admin/appversion/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                version: [
                    {required: true, message: '版本号不能为空', trigger: 'blur'}
                ],
                url: [
                    {required: true, message: '文件不能为空', trigger: 'blur'}
                ],
            },
            uploadAction: config.uploadAction,
            uploadData: {
                folder: "appapk",
            },
            fileList: [],
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/appversion/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        handleUploadSuccess(res, file){
            if(res.code ==1){
                this.model.url = res.data[0]
            }else{
                this.fileList = []
                this.$msg(res.msg)
            }
        },
        beforeUpload(file){
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                this.$message.error('文件大小不能超过 20MB!');
            }
            return isLt20M;
        },
    }
};
</script>